import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=c63aa804&"
import script from "./DocumentUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUpload.vue?vue&type=style&index=0&id=c63aa804&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports